import * as React from 'react'
import type {SVGProps} from 'react'
const SvgSecure = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={21} viewBox="0 0 17 21" {...props}>
        <path
            fill="#55449a"
            fillRule="evenodd"
            d="M8.5 0c3.125 0 5.667 2.355 5.667 5.25l-.001 2.624.709.001c1.171 0 2.125.883 2.125 1.969v9.187C17 20.117 16.046 21 14.875 21H2.125C.954 21 0 20.117 0 19.031V9.844c0-1.086.954-1.969 2.125-1.969l.708-.001V5.25C2.833 2.355 5.375 0 8.5 0m6.375 9.188H2.125c-.39 0-.708.293-.708.656v9.187c0 .362.318.657.708.657h12.75c.39 0 .708-.295.708-.657V9.844c0-.363-.318-.657-.708-.657zM8.5 11.375c1.042 0 1.889.785 1.889 1.75 0 .733-.489 1.362-1.18 1.622v2.097c0 .362-.318.656-.709.656s-.708-.294-.708-.656l-.001-2.097c-.691-.26-1.18-.89-1.18-1.622 0-.965.847-1.75 1.889-1.75m0 1.313c-.26 0-.472.195-.472.437s.212.438.472.438.472-.197.472-.438c0-.242-.212-.438-.472-.438zm0-11.376c-2.343 0-4.25 1.767-4.25 3.938l-.001 2.624h8.5l.001-2.624c0-2.17-1.907-3.938-4.25-3.938"
        />
    </svg>
)
export default SvgSecure
